import { useContext, useState } from 'react';
import { useMutation } from "@apollo/client";
import DialogDelete from "../../Utils/DialogDelete"
import {DELETE_PUBLIC_FORUM} from "../../Schema/PublicForum"
import { AuthContext } from '../../Context/AuthContext';
import { IconButton, Stack, Typography } from '@mui/material';
import {useGetWorkGroupById} from "../../Hooks/useGetWorkGroupById";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PublicForumForm from "../../Components/PublicForum/PublicForumForm";

export default function PublicForumAction({item, setRefetch}) {

    // Change Language
    const { t, setAlert } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);


    const [openEdit, setOpenEdit] = useState(false);
    const handleOpenEdit = () => {
        setOpenEdit(true);
    }
    const handleCloseEdit = () => setOpenEdit(false);

    //Modal delete
    const [openDel, setOpenDel] = useState(false);
    const handleOpenDel = () => setOpenDel(true);
    const handleCloseDel = () => setOpenDel(false);

      const [deletePublicForum] = useMutation(DELETE_PUBLIC_FORUM, {
        onCompleted: ({ deletePublicForum }) => {
          setLoading(false);
          if (deletePublicForum?.isSuccess === true) {
            setAlert(true, "success", deletePublicForum?.message);
            handleCloseDel();
            setRefetch();
          } else {
            setAlert(true, "error", deletePublicForum?.message);
          }
        },
        onError: (error) => {
          console.log("Error", error?.message);
        },
      });
    
      const handleDelete = () => {
        deletePublicForum({
          variables: {
            id: item?._id,
          },
        });
      };

    return (
        <>
            <Stack direction={"row"} justifyContent={'center'} >
                <IconButton onClick={handleOpenEdit}>
                    <BorderColorIcon sx={{ color: "Orange", fontSize: "20px" }} />
                </IconButton>
                <IconButton onClick={handleOpenDel}>
                    <DeleteOutlineIcon sx={{ color: "Red", fontSize: "22px" }} />
                </IconButton>
            </Stack>

            <PublicForumForm
                open={openEdit}
                editData={item}
                setRefetch={setRefetch}
                handleClose={handleCloseEdit}
                dialogTitle={"Update"}
            />

            <DialogDelete
                open={openDel}
                handleClose={handleCloseDel}
                loading={loading}
                deleteTitle={t("modal_title_delete_public_forum")}
                handleDelete={handleDelete}
                editData={item}
            />
        </>
    )
}